(() => {
  function setup(form) {
    if (form.dataset.atrInit) return;
    const root = form.closest('.product-info') || form.parentElement;
    let variants, labels;
    try {
      variants = JSON.parse(form.querySelector('[data-atr-variants]').textContent);
      labels = JSON.parse(form.querySelector('[data-atr-purchase-labels]').textContent);
    } catch { return; }
    if (!variants.length) return;
    form.dataset.atrInit = 'true';
    const groups = Array.from(form.querySelectorAll('[data-atr-option-group]'));
    const id = form.querySelector('[data-atr-variant-id]');
    const select = form.querySelector('[data-ar-mobile-size]');
    const add = form.querySelector('[data-atr-add-btn]');
    const label = form.querySelector('[data-atr-add-label]');
    const status = form.querySelector('[data-atr-variant-status]');
    const property = form.querySelector('[data-atr-preorder-property]');
    const express = form.querySelector('[data-atr-express]');
    const notify = root.querySelector('[data-atr-variant-notify]');
    const price = root.querySelector('[data-product-price]');
    const eta = root.querySelector('[data-atrd-eta]');
    const sticky = document.querySelector('[data-atrd-sticky-btn]');
    function apply(variant, updateUrl = false) {
      const available = !!variant?.available;
      const preorder = available && !!variant?.preorder;
      const modal = document.getElementById('atr-notify-modal');
      if (modal && (!variant || available)) modal.hidden = true;
      id.value = variant ? String(variant.id) : '';
      if (select) select.value = id.value;
      groups.forEach((group, index) => group.querySelectorAll('.variant-btn').forEach(button => {
        const active = !!variant && button.dataset.atrOptionValue === variant['option' + (index + 1)];
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      }));
      add.disabled = !available;
      add.setAttribute('aria-disabled', String(!available));
      label.textContent = !variant ? labels.choose : preorder ? labels.preorder : available ? labels.add : labels.soldout;
      if (status) {
        status.textContent = preorder ? labels.notice : variant && !available ? labels.soldout : '';
        status.hidden = !status.textContent;
      }
      if (property) property.disabled = !preorder;
      if (express) express.hidden = !available || preorder;
      if (notify) {
        notify.hidden = !variant || available;
        notify.setAttribute('data-atr-size', variant?.option1 || '');
      }
      if (price && variant) price.textContent = variant.price;
      if (eta) eta.textContent = preorder ? labels.notice : labels.delivery;
      if (sticky) { sticky.disabled = !available; sticky.textContent = label.textContent; }
      form.classList.remove('atr-needs-size');
      id.dispatchEvent(new Event('change', { bubbles: true }));
      if (updateUrl) {
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
    }
    const lookup = value => variants.find(v => String(v.id) === String(value));
    const fromUrl = () => variants.length === 1 ? variants[0] : lookup(new URLSearchParams(location.search).get('variant'));
    apply(fromUrl());
    select?.addEventListener('change', () => apply(lookup(select.value), true));
    groups.forEach(group => group.addEventListener('click', event => {
      const button = event.target.closest('[data-atr-option-value]');
      if (!button || button.disabled || !group.contains(button)) return;
      const values = groups.map(g => g === group ? button.dataset.atrOptionValue : g.querySelector('.active')?.dataset.atrOptionValue);
      const variant = variants.find(v => values.every((value, index) => value === v['option' + (index + 1)]));
      apply(variant, true);
    }));
    form.addEventListener('submit', event => {
      const variant = lookup(id.value);
      if (!variant?.available) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!variant) {
          form.classList.add('atr-needs-size');
          if (status) { status.textContent = labels.choose; status.hidden = false; }
          (select?.offsetParent ? select : form.querySelector('.variant-btn:not([disabled])'))?.focus();
        }
      }
    }, true);
    window.addEventListener('popstate', () => apply(fromUrl()));
    window.addEventListener('pageshow', () => apply(fromUrl()));
  }
  const init = () => document.querySelectorAll('[data-atr-product-form]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
